import axios from "../../apiFc24";

export const deleteSavedSquad = async (uuid: string) => {
  const res = await axios.delete("/saved-squads/" + uuid);
  return res.data;
};
